import { useRef, useState } from "react";
import { UploadCloud, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function ImageUpload({ value, onChange, label = "Bild" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Bild hochgeladen.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <label className="block text-xs font-semibold uppercase tracking-wider text-[var(--mf-grey)] mb-1.5">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <img src={value} alt="Vorschau" className="w-16 h-16 object-cover border border-[var(--mf-line)]" />
        ) : (
          <div className="w-16 h-16 border border-dashed border-[var(--mf-line)] flex items-center justify-center text-[var(--mf-grey)] text-[10px] text-center">kein Bild</div>
        )}
        <div className="flex flex-col gap-2">
          <input ref={ref} type="file" accept="image/*" onChange={upload} className="hidden" data-testid="image-upload-input" />
          <button type="button" onClick={() => ref.current?.click()} disabled={busy}
            className="text-xs inline-flex items-center gap-1.5 border border-[var(--mf-line)] px-3 py-2 hover:bg-[var(--mf-mist)] disabled:opacity-60" data-testid="image-upload-btn">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <UploadCloud size={13} />} Bild hochladen
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="text-xs text-[var(--mf-red)] inline-flex items-center gap-1"><X size={12} /> Entfernen</button>
          )}
        </div>
      </div>
      <input className="w-full mt-2 bg-white border border-[var(--mf-line)] px-3 py-2 text-sm focus:border-[var(--mf-red)]"
        placeholder="oder Bild-URL / Pfad" value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
